import { db } from "@/utils/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const updateConstants = async (action, item, constant) => {
  try {
    const docRef = doc(db, "constants", "default");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      const updatedData = { ...data };

      if (action === "add" && item) {
        updatedData[constant] = [...(data[constant] || []), item];
      } else if (action === "remove" && item) {
        updatedData[constant] = (data[constant] || []).filter(
          (i) => i !== item
        );
      }

      await setDoc(docRef, updatedData, { merge: true });
      console.log("Constants successfully updated.");
    } else {
      console.error("Document does not exist.");
    }
  } catch (error) {
    console.error("Error modifying constants:", error.message || error);
  }
};

export default updateConstants;
